import env from '@/config/env';
var stripMedia = function (url) { return url.replace(env.IMAGES_URL, ''); };
export function asset(src, options) {
    if (options === void 0) { options = {}; }
    if (!options.fm) {
        options.auto = 'format';
    }
    var optionString = Object.keys(options)
        .map(function (key) { return key + "=" + options[key]; })
        .filter(function (v) { return v !== null; })
        .join('&');
    if (optionString.length > 0) {
        return "" + env.ASSETS_URL + stripMedia(src) + "?" + optionString;
    }
    return "" + env.ASSETS_URL + stripMedia(src);
}
